// ERTH Essentials — global scripts

document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Random gentle tilt for polaroids
  document.querySelectorAll('.polaroid').forEach(function (card, i) {
    var tilt = (Math.sin(i * 1.7) * 3).toFixed(1);
    card.style.setProperty('--tilt', tilt + 'deg');
  });
});
